import { ShieldAlert, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@nasam/ui";

export interface UnauthorizedScreenProps {
  readonly onGoHome: () => void;
}

export function UnauthorizedScreen({ onGoHome }: UnauthorizedScreenProps) {
  const { t } = useTranslation("permissions", { keyPrefix: "unauthorized" });

  return (
    <div
      role="alert"
      className="animate-rise flex min-h-screen flex-col items-center justify-center p-6"
    >
      <div className="w-full max-w-[32.5rem] rounded-2xl border border-container-default-border bg-container-default-background p-8 text-center">
        <div className="relative mx-auto mb-6 flex size-24 items-center justify-center rounded-full bg-badge-bg-light-red">
          <ShieldAlert
            className="size-10 text-badge-text-red"
            strokeWidth={1.5}
            aria-hidden="true"
          />
          <span className="absolute -top-1 -end-1 flex size-7 items-center justify-center rounded-full bg-fail-text text-neutral-white">
            <X className="size-4" strokeWidth={3} aria-hidden="true" />
          </span>
        </div>

        <h1 className="text-heading-h3-bold text-text">{t("title")}</h1>
        <p className="mt-2 text-body-m-r text-text-placeholder">
          {t("description")}
        </p>

        <div className="mt-6 flex justify-center">
          <Button
            variant="primary"
            className="flex-1 sm:flex-none sm:px-6"
            onClick={onGoHome}
          >
            {t("goHome")}
          </Button>
        </div>
      </div>
    </div>
  );
}
